import { ReactNode } from "react";
import { GuxInlineAlert } from "genesys-spark-components-react";
import "./FormBanner.less";

export enum BannerType {
    INFO = "info",
    WARNING = "warning",
    ERROR = "error",
}

export function FormBanner({
    children,
    type,
}: {
    children: ReactNode;
    type: BannerType;
}) {
    return (
        <GuxInlineAlert className="FormBanner" accent={type}>
            {children}
        </GuxInlineAlert>
    );
}
